import { AxiosError, AxiosResponse } from 'axios';
import instance from 'api';
import { ApiResponse, BaseApi } from 'baseApi';
import { endpoints } from 'endpoints.config';
import {
  IArchivingInfo,
  ISchool,
  SchoolParser,
} from 'pages/manageSchool/models';

const UNKOWN_ERROR_MESSAGE = 'Sorry, something went wrong. Please try again.';

export class SchoolApi extends BaseApi {
  // get school details
  public static getSchoolDetails = async (): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.get(
        endpoints.manageschool.getSchoolDetails
      );

      if (SchoolApi.isResponseSuccessful(result.data)) {
        const data = SchoolParser.parseGetSchoolDetails(result.data.details);
        return SchoolApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          //TODO: build error parser
          // const message = UsersParser.parseError(errors);
          // return UsersApi.errorResponse(message);
          return null;
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.errors;
        if (errors) {
          //TODO: build error parser
          // const message = UsersParser.parseError(errors);
          // return UsersApi.errorResponse(message);
          return null;
        }
      }
      return SchoolApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };

  //submit update school form
  public static submitSchoolDetails = async (values: ISchool): Promise<any> => {
    try {
      let payload = SchoolParser.buildSubmitSchoolPayload(values);

      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.manageschool.updateSchoolDetails,
        payload
      );

      if (SchoolApi.isResponseSuccessful(result.data)) {
        const data = SchoolParser.parseGetSchoolDetails(result.data.details);
        return SchoolApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = SchoolParser.parseError(errors);
          return SchoolApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          const message = SchoolParser.parseError(errors);
          return SchoolApi.errorResponse(message);
        }
      }
      return SchoolApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };

  //submit update school form
  public static submitSchoolDetailsIForm = async (data: any): Promise<any> => {
    try {
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      };

      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.manageschool.updateSchoolDetails,
        data,
        config
      );

      if (SchoolApi.isResponseSuccessful(result.data)) {
        const data = SchoolParser.parseGetSchoolDetails(result.data.details);
        return SchoolApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = SchoolParser.parseError(errors);
          return SchoolApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          const message = SchoolParser.parseError(errors);
          return SchoolApi.errorResponse(message);
        }
      }
      return SchoolApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };

  //submit archiving data form
  public static submitArchiveDate = async (
    values: IArchivingInfo
  ): Promise<any> => {
    try {
      let payload = SchoolParser.buildArchiveSchoolPayload(values);

      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.manageschool.updateArchivingDate,
        payload
      );
      if (SchoolApi.isResponseSuccessful(result.data)) {
        const data = SchoolParser.parseGetSchoolDetails(result.data.details);
        return SchoolApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = SchoolParser.parseError(errors);
          return SchoolApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          //TODO: build error parser
          const message = SchoolParser.parseError(errors);
          return SchoolApi.errorResponse(message);
        }
      }
      return SchoolApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };

  //submit archiving now
  public static submitArchiveNow = async (
    values: IArchivingInfo
  ): Promise<any> => {
    try {
      let payload = SchoolParser.buildArchiveNowPayload(values);

      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.manageschool.archiveNow,
        payload
      );
      if (SchoolApi.isResponseSuccessful(result.data)) {
        const data = SchoolParser.parseGetSchoolDetails(result.data.details);
        return SchoolApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = SchoolParser.parseError(errors);
          return SchoolApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          const message = SchoolParser.parseError(errors);
          return SchoolApi.errorResponse(message);
        }
      }
      return SchoolApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };

  //get countries list
  public static getCountriesList = async (): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.get(
        endpoints.public.countries
      );

      if (SchoolApi.isResponseSuccessful(result.data)) {
        return SchoolApi.successResponse(result.data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = SchoolParser.parseError(errors);
          return SchoolApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.errors;
        if (errors) {
          const message = SchoolParser.parseError(errors);
          return SchoolApi.errorResponse(message);
        }
      }
      return SchoolApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };
}
